// import { get, post } from '../../http';
import axios from 'axios';
import Page from '@/global/util/Page';
import { BASE_URL } from '@/global/util/constants';

const state = {
  page: new Page(),
  datePage: new Page()
};

const getters = {
  page: state => state.page,
  datePage: state => state.datePage
};

const mutations = {};

const actions = {
  async getReportData ({ state, commit }, { request, platform, params, changeType }) {
    try {
      state.page.loading = true;
      const isAgencyOrAdmin = ['agency', 'admin'].includes(platform)
      const methodName = isAgencyOrAdmin ? 'get' : 'post';
      const data = isAgencyOrAdmin ? { params } : params;
      if (changeType) {
        state.page.setPageData({
          ...state.page,
          data: state.page.getPageData(state.page.originalData, params.size, params.page),
          loading: false
        }, false);
      } else {
        const res = await axios[methodName](`${BASE_URL}/${platform}/data/first`, data);
        state.page.setOriginalData(res.data.data.list)
        state.page.setPageData({
          ...res.data.data,
          data: state.page.getPageData(state.page.originalData, params.size, params.page),
        }, false);
      }
    } catch (error) {
      state.page.loading = false;
    }
  },
  async getDateDetailData ({ state, commit }, { request, platform, params }) {
    state.datePage.loading = true;
    const res = await axios.get(`${BASE_URL}/${platform}/data/firstDetail`, { params });
    state.datePage.setPageData(res.data.data, false);
  },
  async getAccountNameList ({ state, commit }, { request, platform }) {
    const res = await axios.get(`${BASE_URL}/${platform}/data/firstOption`)
    return res.data
  },
  async getAccountTypeList ({ state, commit }, { request, platform }) {
    const res = await axios.get(`${BASE_URL}/${platform}/data/firstAccountType`)
    return res.data
  },
  async getChartData ({ state, commit }, { request, platform, params }) {
    const res = await axios.post(`${BASE_URL}/${platform}/data/chart`, params);
    const { data, header, list } = res.data.data || {};
    return { header, data: data || list || [] };
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
